import Redux from "./assets/Projects/redux.png";
import Karnali from "./assets/Projects/karnali.png";
import DeepFake from "./assets/Projects/deepfake.png";
import SafeInbox from "./assets/Projects/safeinbox.png";
import ReadWise from "./assets/Projects/readwise.png";
import DeFIFA from "./assets/Projects/defifa.png";
import LuciMart from "./assets/Projects/lucimart.png";

export const PROJECTS = [
  {
    id: 0,
    image: Redux,
    name: "REDUX",
    technologyUsed: "Next, TypeScript, CSS, Redux, C#, Asp.Net",
    description:
      "The Redux NP-Complete Portal is an interactive platform for exploring and visualizing NP-complete problems through interactive tools and algorithms.",
    url: "https://redux.portneuf.cose.isu.edu/",
  },
  {
    id: 1,
    image: Karnali,
    name: "Karnali-Nepal",
    technologyUsed:
      "React, Typescript, JavaScript, Python, Django, D3, Apex Chart, ReChart, Tailwind CSS, Redex, Redux Sauce, Redux-Saga",
    description:
      "The Karnali Project Portal is a government platform for managing and tracking development projects in Karnali, Nepal. It provides insights into project progress, budgets, and implementation status to enhance transparency and efficiency.",
    url: "https://projects.karnali.gov.np/",
  },
  {
    id: 2,
    image: DeepFake,
    name: "AI DeFake: Spot the Unreal",
    technologyUsed:
      "Python, TensorFlow, Keras, Kaggle, Pytorch, ResNet, OpenCV, NumPy, Pandas",
    description:
      "This Deepfake Detection project utilizes hybrid GAN-based models and deep learning techniques to identify manipulated images and videos. By combining CNNs (ResNet) and LSTM, it enhances accuracy in detecting facial forgeries and deepfake content.",
    url: "https://github.com/Sabal-Subedi/AI-DeFake--Spot-the-Unreal",
  },
  {
    id: 3,
    image: SafeInbox,
    name: "SafeInbox: AI Against Phishing",
    technologyUsed: "TensorFlow, PyTorch, NLP, Regex, Pandas, NumPy",
    description:
      "SafeInbox is an AI-powered phishing detection system that analyzes emails using ML, NLP, and cybersecurity techniques to identify suspicious links, spoofed senders, and fraudulent content, keeping users safe from phishing attacks.",
    url: "https://github.com/Sabal-Subedi/SafeInbox-AI-Against-Phishing",
  },
  {
    id: 4,
    image: ReadWise,
    name: "ReadWise",
    technologyUsed:
      "React, CSS, Redux, REST API, Flask, TensorFlow, Keras, Pandas, NumPy",
    description:
      "ReadWise uses AI and Machine Learning to deliver personalized book recommendations, enhancing the reading experience with accurate and dynamic suggestions tailored to user preferences.",
    url: "https://github.com/Sabal-Subedi/ReadWise",
  },
  {
    id: 5,
    image: DeFIFA,
    name: "DeFIFA",
    technologyUsed: "React, Typescript, Redux, SCSS, JSON, ReChart, Apex Chart",
    description:
      "DeFifa is an interactive FIFA22 player analysis platform that lets users search, filter, and visualize player stats with a seamless UI, providing real-time insights for scouting and performance analysis.",
    url: "https://github.com/Sabal-Subedi/DeFifa",
  },
  {
    id: 6,
    image: LuciMart,
    name: "LuciMart",
    technologyUsed:
      "React, Typescript, Redux, Node, Express, CSS, Nodemailer, JWT, MongoDB, Axios, JSON",
    description:
      "Luci Store is a feature-rich shopping platform that offers a smooth and interactive user experience. Built with modern web technologies, it provides a fully responsive and user-friendly interface for browsing, searching, and purchasing products online.",
    url: "https://github.com/Sabal-Subedi/LuciMart",
  },
];

export const SKILLS = [
  { name: "ReactJs", initialRating: 4 },
  { name: "JavaScript", initialRating: 4 },
  { name: "Redux | Redux-Saga | Redux Sauce", initialRating: 4 },
  { name: "Nodejs", initialRating: 3 },
  { name: "Nextjs", initialRating: 3 },

  { name: "Html", initialRating: 4 },
  { name: "CSS", initialRating: 4 },
  { name: "SCSS", initialRating: 4 },

  { name: "TypeScript", initialRating: 4 },
  { name: "Java | C# | Asp.Net", initialRating: 4 },
  { name: "Python | Flask | Keras | TensorFlow | PyTorch", initialRating: 4 },

  {
    name: "AntD | ReactStrap | Material UI | BootStrap | Tailwind CSS",
    initialRating: 4,
  },
  { name: "MySQL | sqLite3 | TinyDB | MongoDB", initialRating: 3 },

  { name: "Git", initialRating: 4 },
];

export const TOOLS = [
  "Visual Studio Code",
  "Eclipse",
  "IntelliJ",
  "Sublime Text",
  "Figma",
  "Jupyter Notebook",
  "Google Colab",
  "Visual Studio Code",
  "Trello",
  "Firebase",
  "Git | GitLens",
  "Chrome DevTools",
  "Npm (Node Package Manager)",
  "Pip | Yarn",
  "Linux",
  "Docker",
  "Postman",
];
